import { create, v } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/widgets/middleware/theme';

// make generated .d.ts file valid
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { WNodeFactory, WidgetProperties, DNode } from '@dojo/framework/core/interfaces';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ThemeProperties } from '@dojo/framework/core/middleware/theme';

import { TopicDetails } from 'lcc-state/interfaces';
import { TopicWidgetProperties } from 'book-widgets/interfaces';

import css from '@holmescorp/book-widgets/css/topicpage.m.css';

const factory = create({ theme }).properties<TopicWidgetProperties>();

export const Term = factory(({ properties, middleware: { theme } }) => {
	const { topicdata, additionalClasses = [] } = properties();
	const data: TopicDetails = topicdata as any;
	const { children = [] } = data;
	const termtext = children[0] as any as string;
	const themeCss = theme.classes(css);

	return v('span', { classes: [themeCss.term, ...additionalClasses] }, [termtext]);
});
